// @flow
import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import './styles.scss'

const isMobile = browserCheck.isMobile

export class Icons extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {}
  }

  componentDidMount() {}

  render() {
    const elements = ['one', 'two', 'three']
    const items = []
    for (let i = 0; i < this.props.count; i++) {
      items.push(<img className='ui image' src={this.props.image} key={i} />)
    }

    return (
      <div className='icons'>
        <div>{items}</div>
      </div>
    )
  }
}
